import LevelMapData from './LevelMapData'

export default {
  size: {
    width: 800,
    height: 600
  },
  elements: {
    size: {
      width: 40,
      height: 40
    },
    levelLayout: LevelMapData
  },
  grid: {
    x: 20,
    y: 15
  },
  player: {
    items: [],
    position: {
      x: 0,
      y: 0
    },
    step: 1
  },
  state: {
    prompt: {
      isOpen: false
    },
    map: {
      isHidden: false
    },
    items: {}
  }
}